import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { IOSSwitch } from "../../../../components/switch/IOSSwitch";

import {
  Icon,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import Image from "../../../../components/Images/Image";
import {
  open_dialog,
  parseQuery,
  startLoader,
  stopLoader,
} from "../../../../lib/global";
import { MERCHANT_FLASH_SALE_ADD_PRODUCT } from "../../../../lib/constant";
import InputField from "../../../../components/formControl/input/InputField";
import SelectInput from "../../../../components/select";
import {
  getAllFlashSaleProductByMerchantId,
  getTimeSLotBySlotId,
  createFlashSaleProduct,
} from "../../../../redux/actions/marketing.action";
import { getLocalStorage } from "../../../../lib/session";
import { showToast } from "../../../../lib/global";
import {
  v2CreateFlashSaleProductByMerchant,
  v2GetTimeSLotBySlotIdByMerchant,
} from "../../../../redux/actions/merchant/marketing.merchant.action";

const MerchantFlashDealsProductCreate = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [buttonTimeSlot, setButtonTimeSlot] = useState(false);
  const [allProductData, setAllProductData] = useState([]);
  const [timeSlotDateState, setTimeSlotDateState] = useState();
  const [campaignStockState, setCampaignStockState] = useState();
  const [unitCappedState, setUnitCappedState] = useState();
  const [status, setStatus] = useState("Disable");
  const { promoslotid } = parseQuery(history.location.search) || {};
  let filterData = {};
  let productData = [];
  const [variationInfo, setVariationInfo] = useState({});
  const [variationData, setVariationData] = useState([]);
  const [isActivedProduct, setIsActivedProduct] = useState(0);

  const checkExistTimeSlot = (timeSlotDate) => {
    setTimeSlotDateState(timeSlotDate);

    filterData = {
      merchantId: getLocalStorage("storeId"),
      timeSlotDate: timeSlotDate,
    };
    // dispatch(getTimeSLotBySlotId(promoslotid, filterData))
    dispatch(v2GetTimeSLotBySlotIdByMerchant(promoslotid, timeSlotDate))
      .then((data) => {
        if (data.data.data.length > 0) {
          setButtonTimeSlot(false);
          setAllProductData([]);
        } else {
          setButtonTimeSlot(true);
        }

        setTimeout(() => {
          stopLoader();
        }, 1000);
      })
      .catch((err) => {
        setTimeout(() => {
          stopLoader();
        }, 1000);
        console.log({ err });
      });
  };

  const handelAddProduct = () => {
    open_dialog(MERCHANT_FLASH_SALE_ADD_PRODUCT, {
      onSubmit: selectProductSuccess,
      allProductData: allProductData,
      setAllProductData: setAllProductData,
      merchantId: getLocalStorage("storeId"),
    });
  };

  const selectProductSuccess = (data) => {
    console.log(data);
  };

  const saveActionAll = async () => {
    startLoader();
    const flashSaleProducts = allProductData.map((row, index) => {
      let productDataItem = {
        productId: row.productId,
        variation: row.variationList,
      };
      // productData.push(productDataItem);
      return productDataItem;
    });

    let payload = {
      promoSlotId: promoslotid,
      merchantId: getLocalStorage("storeId"),
      date: timeSlotDateState,
      productData: flashSaleProducts,
    };

    if (isActivedProduct === 0) {
      stopLoader();
      showToast(
        "At least one product must be activated and fill in all product prices, please!",
        "error"
      );
    } else {
      setTimeout(() => {
        // dispatch(createFlashSaleProduct(payload))
        dispatch(v2CreateFlashSaleProductByMerchant(payload))
          .then((response) => {
            stopLoader();
            history.push(
              `/merchant/marketing/promo/flash-deals/time-slot-listing?promoslotid=${promoslotid}`
            );
          })
          .catch((error) => {
            stopLoader();
            showToast("Fill in all product prices, please!", "error");
          });
      }, 500);
    }
  };

  const onChangeVariation = (arrayVariation, row, i, e) => {
    const key = e.target.name;
    const value = e.target.value;
    const newObject = { [key]: value };

    arrayVariation.map((rowData, indexData) => {
      if (indexData == i) {
        if (key === "campaignStock") {
          rowData.campaignStock = value;
        } else if (key === "unitCapped") {
          rowData.unitCapped = value;
        } else if (key === "discountPrice") {
          rowData.discountPrice = value;
        } else if (key === "teamCampaignStock") {
          rowData.teamCampaignStock = value;
        } else if (key === "teamUnitCapped") {
          rowData.teamUnitCapped = value;
        } else if (key === "teamDiscountPrice") {
          rowData.teamDiscountPrice = value;
        }
        // Object.assign(rowData, newObject)
      }
    });
    setVariationData(arrayVariation);
  };

  const onChangeStatus = (arrayVariation, row, i, e) => {
    const keyCheck = e.target.name;
    const valCheck = e.target.checked;
    arrayVariation.map((rowData, indexData) => {
      if (indexData == i) {
        if (valCheck) {
          setIsActivedProduct((a) => a + 1);
          if (keyCheck === "isActive") {
            rowData.isActive = valCheck;
            rowData.teamIsActive = valCheck;
          }
          //  else if (keyCheck === "teamIsActive") {
          //   rowData.teamIsActive = valCheck;
          // }
        } else {
          setIsActivedProduct((a) => a - 1);
          rowData.isActive = valCheck;
          rowData.teamIsActive = valCheck;
        }
      }
    });
  };

  const onChangeVariationInfo = (e) => {
    const key = e.target.name;
    const value = e.target.value;
    setVariationInfo((pre) => ({ ...pre, [key]: value }));
  };

  const handleUpdateAll = () => {
    allProductData.map((row, index) => {
      row.variationList.map((r, i) => {
        Object.assign(r, variationInfo);
      });
    });
  };
  console.log(allProductData);

  useEffect(() => {
    allProductData.map((r, i) => {
      setVariationData(r.variationList);
    });
  }, [variationData]);

  return (
    <React.Fragment>
      <div className=" d-flex flex-column justify-content-between container_body vh-100">
        <div className="container-fluid">
          <div className="card p-4 px-5 mb-3">
            <h6>BASIC INFORMATION</h6>
            <br />
            <div>
              <div className="row">
                <label className="col-md-3 d-flex justify-content-end">
                  Time Slot
                </label>
                <input
                  type="date"
                  className="form-control col-md-3"
                  onChange={(e) => checkExistTimeSlot(e.target.value)}
                />
                {/*<div className={`d-${buttonTimeSlot == true ? "block" : "none"}`}>*/}
                {/*  <button className="ml-5 rounded btn btn-danger text-nowrap p-2 px-4">Add Team Slot</button>*/}
                {/*</div>*/}
              </div>
              <br />
              <div className="row">
                <label className="col-md-3 d-flex justify-content-end">
                  Product criteria
                </label>
                <textarea
                  id="textarea"
                  className="form-control col-md-7"
                  style={{ minHeight: "20vh" }}
                  placeholder="To be include"
                />
              </div>
            </div>
          </div>

          <div className="card p-4 mb-3">
            <div>
              <div className="float-left">
                <h6>FLASH DEALS PRODUCT</h6>
                <p className="fntSz14 mb-0 text-secondary">
                  Add product to participate in flash sale event.
                  {/*You have <span className="text-danger">5</span> */}
                  {/*out of <span className="text-danger">5</span> products joining flash sale.*/}
                </p>
              </div>
              <div
                className={`float-right d-${
                  buttonTimeSlot == true ? "block" : "none"
                }`}
              >
                <button
                  onClick={() => handelAddProduct()}
                  type="button"
                  className="rounded btn btn-danger text-nowrap p-2 px-4"
                >
                  {" "}
                  Add Product
                </button>
              </div>
            </div>
            <hr />
            <br />
            {/*<div className={`d-${buttonTimeSlot == true ? "block" : "none"}`}>*/}
            {/*  <div className="d-flex flex-row justify-content-center bg-light rounded p-3">*/}
            {/*    <div className="d-flex flex-row align-items-center w-60">*/}
            {/*      <p className="mt-4 text-nowrap">Batch Updated</p>*/}
            {/*      <div className="d-flex mx-4 flex-column">*/}
            {/*        <label>Campaign Stock</label>*/}
            {/*        <input*/}
            {/*          formClass="col-12 p-0"*/}
            {/*          type="number"*/}
            {/*          id="stockInfo"*/}
            {/*          placeholder="Input"*/}
            {/*          name="stockInfo"*/}
            {/*          onChange={onChangeVariationInfo}*/}
            {/*        />*/}
            {/*      </div>*/}
            {/*      <div className="d-flex flex-column w-30">*/}
            {/*        <label>Unit Capped</label>*/}
            {/*        <div >*/}
            {/*          <input*/}
            {/*            formClass="col-12 p-0"*/}
            {/*            type="number"*/}
            {/*            id="unitCappedInfo"*/}
            {/*            placeholder="Input"*/}
            {/*            name="unitCappedInfo"*/}
            {/*            onChange={onChangeVariationInfo}*/}
            {/*          />*/}
            {/*        </div>*/}
            {/*      </div>*/}
            {/*    </div>*/}
            {/*    <button*/}
            {/*      className="btn btn-outline-danger m-3 px-3"*/}
            {/*      onClick={handleUpdateAll}*/}
            {/*    >Update All</button>*/}
            {/*  </div>*/}
            {/*</div>*/}
            <br />

            {allProductData &&
              allProductData.length > 0 &&
              allProductData.map((row, index) => (
                <div className="mb-3" key={index}>
                  <div>
                    <div className="float-left d-flex align-items-center flex-nowrap ">
                      <Image
                        src={row.productImages}
                        alt={"photo"}
                        className="teamPurchase_page_product_image"
                      />
                      <div className="px-2">{row.title}</div>
                    </div>
                    {/*<div className={`float-right d-block`}>*/}
                    {/*  <label className="px-3">Participate</label>*/}
                    {/*  <IOSSwitch*/}
                    {/*    checked={status}*/}
                    {/*    onChange={(e) => setStatus(e.target.checked)}*/}
                    {/*  />*/}
                    {/*</div>*/}
                  </div>
                  <br />
                  <br />
                  <br />

                  <div className={`float-right d-block w-100`}>
                    <div
                      className="border"
                      style={{ borderRadius: "10px", overflow: "hidden" }}
                    >
                      <div className=" bg-light">
                        <div className="pl-3 pt-3 mb-0 fntSz18 bg-light">
                          Individual Purchase
                        </div>
                        <hr />
                      </div>
                      <div className="mx-3">
                        <TableContainer>
                          <Table
                            sx={{ minWidth: 650 }}
                            stickyHeader
                            aria-label="sticky table"
                          >
                            <TableHead>
                              <TableRow>
                                {row.variation &&
                                  row.variation.length > 0 &&
                                  row.variation.map((item, idx) => (
                                    <TableCell
                                      className="th_cell"
                                      component="th"
                                      align="left"
                                      key={idx}
                                    >
                                      <div className="d-flex  ">
                                        <div>{item?.name}</div>
                                      </div>
                                    </TableCell>
                                  ))}
                                <TableCell
                                  className="th_cell"
                                  component="th"
                                  align="left"
                                >
                                  <div className="d-flex  ">
                                    <div>Original Price</div>
                                  </div>
                                </TableCell>
                                <TableCell
                                  className="th_cell "
                                  component="th"
                                  align="left"
                                >
                                  <div className="d-flex  ">
                                    <div>Discounted Price</div>
                                  </div>
                                </TableCell>
                                <TableCell
                                  className="th_cell "
                                  component="th"
                                  align="left"
                                >
                                  <div className="d-flex  ">
                                    <div>Campaign Stock</div>
                                  </div>
                                </TableCell>
                                <TableCell
                                  className="th_cell "
                                  component="th"
                                  align="left"
                                >
                                  <div className="d-flex  ">
                                    <div>Stock</div>
                                  </div>
                                </TableCell>
                                <TableCell
                                  className="th_cell "
                                  component="th"
                                  align="left"
                                >
                                  <div className="d-flex  ">
                                    <div>Unit Capped</div>
                                  </div>
                                </TableCell>

                                <TableCell
                                  className="table_action_head text-secondary"
                                  component="th"
                                >
                                  Enable/Disable
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {row.variationList &&
                                row.variationList.length > 0 &&
                                row.variationList
                                  .filter((item) => {
                                    return (
                                      item[
                                        row.variation.map(
                                          (item) => item.name
                                        )[0]
                                      ].trim().length !== 0
                                    );
                                  })
                                  .map((row1, index1) => (
                                    <TableRow
                                      key={index1}
                                      className="border-0"
                                      sx={{
                                        "&:last-child td, &:last-child th": {
                                          border: 0,
                                        },
                                      }}
                                    >
                                      {row.variation.map((item, idx) => (
                                        <TableCell
                                          align="left"
                                          className="td_cell border-0"
                                          key={idx}
                                        >
                                          {row1[item.name]}
                                        </TableCell>
                                      ))}
                                      <TableCell
                                        align="left"
                                        className="td_cell border-0"
                                      >
                                        RM. {row1?.price || "0"}
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        className="td_cell border-0"
                                      >
                                        <InputField
                                          className="input_icon_left"
                                          formClass="col-12 p-0"
                                          type="number"
                                          id="discountPrice"
                                          icon="currency"
                                          placeholder="Input"
                                          name="discountPrice"
                                          onChange={(e) =>
                                            onChangeVariation(
                                              row.variationList,
                                              row1,
                                              index1,
                                              e
                                            )
                                          }
                                          required={false}
                                        />
                                        <div className="error_container mr-3 rounded px-1 d-flex"></div>
                                      </TableCell>

                                      <TableCell
                                        align="left"
                                        className="td_cell border-0"
                                      >
                                        <input
                                          type="number"
                                          id="campaignStock"
                                          name="campaignStock"
                                          placeholder="Input"
                                          className="w-75 form-control"
                                          // value={row1.campaignStock}
                                          onChange={(e) =>
                                            onChangeVariation(
                                              row.variationList,
                                              row1,
                                              index1,
                                              e
                                            )
                                          }
                                          required={false}
                                        />
                                        <div className="error_container mr-3 rounded px-1 d-flex"></div>
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        className="td_cell border-0"
                                      >
                                        {row1?.stock || "N/A"}
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        className="td_cell border-0"
                                      >
                                        <input
                                          type="text"
                                          placeholder="Input"
                                          className="w-75 form-control"
                                          id="unitCapped"
                                          name="unitCapped"
                                          onChange={(e) =>
                                            onChangeVariation(
                                              row.variationList,
                                              row1,
                                              index1,
                                              e
                                            )
                                          }
                                          required={false}
                                        />
                                        <div className="error_container mr-3 rounded px-1 d-flex"></div>
                                      </TableCell>

                                      <TableCell className="d-flex border-0 table_action_item">
                                        <IOSSwitch
                                          // onChange={(e)=> onChangeVariation(row.variationList, row1, index1, e)}
                                          name="isActive"
                                          onChange={(e) =>
                                            onChangeStatus(
                                              row.variationList,
                                              row1,
                                              index1,
                                              e
                                            )
                                          }
                                        />
                                      </TableCell>
                                    </TableRow>
                                  ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </div>
                    </div>
                    <br />

                    <div
                      className="border"
                      style={{ borderRadius: "10px", overflow: "hidden" }}
                    >
                      <div className=" bg-light">
                        <div className="pl-3 pt-3 mb-0 fntSz18">
                          Team Purchase
                        </div>
                        <hr />
                      </div>
                      <div className="mx-3">
                        <TableContainer>
                          <Table
                            sx={{ minWidth: 650 }}
                            stickyHeader
                            aria-label="sticky table"
                          >
                            <TableHead>
                              <TableRow>
                                {row.variation &&
                                  row.variation.length > 0 &&
                                  row.variation.map((item, idx) => (
                                    <TableCell
                                      className="th_cell"
                                      component="th"
                                      align="left"
                                      key={idx}
                                    >
                                      <div className="d-flex">
                                        <div>{item?.name}</div>
                                      </div>
                                    </TableCell>
                                  ))}
                                <TableCell
                                  className="th_cell"
                                  component="th"
                                  align="left"
                                >
                                  <div className="d-flex  ">
                                    <div>Original Price</div>
                                  </div>
                                </TableCell>
                                <TableCell
                                  className="th_cell "
                                  component="th"
                                  align="left"
                                >
                                  <div className="d-flex  ">
                                    <div>Discounted Price</div>
                                  </div>
                                </TableCell>
                                <TableCell
                                  className="th_cell "
                                  component="th"
                                  align="left"
                                >
                                  <div className="d-flex  ">
                                    <div>Campaign Stock</div>
                                  </div>
                                </TableCell>
                                <TableCell
                                  className="th_cell "
                                  component="th"
                                  align="left"
                                >
                                  <div className="d-flex  ">
                                    <div>Stock</div>
                                  </div>
                                </TableCell>
                                <TableCell
                                  className="th_cell "
                                  component="th"
                                  align="left"
                                >
                                  <div className="d-flex  ">
                                    <div>Unit Capped</div>
                                  </div>
                                </TableCell>

                                {/* <TableCell
                                  className="table_action_head text-secondary"
                                  component="th"
                                >
                                  Enable/Disable
                                </TableCell> */}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {row.variationList &&
                                row.variationList.length > 0 &&
                                row.variationList
                                  .filter((item) => {
                                    return (
                                      item[
                                        row.variation.map(
                                          (item) => item.name
                                        )[0]
                                      ].trim().length !== 0
                                    );
                                  })
                                  .map((row2, index2) => (
                                    <TableRow
                                      key={index2}
                                      className="border-0"
                                      sx={{
                                        "&:last-child td, &:last-child th": {
                                          border: 0,
                                        },
                                      }}
                                    >
                                      {row2.teamIsActive == true && (
                                        <>
                                          {row.variation.map((item, idx) => (
                                            <TableCell
                                              align="left"
                                              className="td_cell border-0"
                                              key={idx}
                                            >
                                              {row2[item.name]}
                                            </TableCell>
                                          ))}
                                          <TableCell
                                            align="left"
                                            className="td_cell border-0"
                                          >
                                            RM. {row2?.teamPrice || "0"}
                                          </TableCell>
                                          <TableCell
                                            align="left"
                                            className="td_cell border-0"
                                          >
                                            <InputField
                                              className="input_icon_left"
                                              formClass="col-12 p-0"
                                              type="number"
                                              id="teamDiscountPrice"
                                              icon="currency"
                                              placeholder="Input"
                                              name="teamDiscountPrice"
                                              onChange={(e) =>
                                                onChangeVariation(
                                                  row.variationList,
                                                  row2,
                                                  index2,
                                                  e
                                                )
                                              }
                                              required={false}
                                            />

                                            <div className="error_container mr-3 rounded px-1 d-flex"></div>
                                          </TableCell>

                                          <TableCell
                                            align="left"
                                            className="td_cell border-0"
                                          >
                                            <input
                                              type="text"
                                              placeholder="Input"
                                              className="w-75 form-control"
                                              id="teamCampaignStock"
                                              name="teamCampaignStock"
                                              onChange={(e) =>
                                                onChangeVariation(
                                                  row.variationList,
                                                  row2,
                                                  index2,
                                                  e
                                                )
                                              }
                                              required={false}
                                            />
                                            <div className="error_container mr-3 rounded px-1 d-flex"></div>
                                          </TableCell>
                                          <TableCell
                                            align="left"
                                            className="td_cell border-0"
                                          >
                                            {row2?.stock || "N/A"}
                                          </TableCell>
                                          <TableCell
                                            align="left"
                                            className="td_cell border-0"
                                          >
                                            <input
                                              type="text"
                                              placeholder="Input"
                                              className="w-75 form-control"
                                              id="teamUnitCapped"
                                              name="teamUnitCapped"
                                              onChange={(e) =>
                                                onChangeVariation(
                                                  row.variationList,
                                                  row2,
                                                  index2,
                                                  e
                                                )
                                              }
                                              required={false}
                                            />
                                            <div className="error_container mr-3 rounded px-1 d-flex"></div>
                                          </TableCell>

                                          {/* <TableCell className="d-flex border-0 table_action_item">
                                          <IOSSwitch
                                            // checked={status}
                                            // onChange={(e) => setStatus(e.target.checked)}
                                            name="teamIsActive"
                                            onChange={(e) =>
                                              onChangeStatus(
                                                row.variationList,
                                                row2,
                                                index2,
                                                e
                                              )
                                            }
                                          />
                                        </TableCell> */}
                                        </>
                                      )}
                                    </TableRow>
                                  ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </div>
                    </div>
                    <br />

                    {/*<div className="d-flex flex-row justify-content-end">*/}
                    {/*  <button type="button" className="btn btn-outline-danger px-4 mx-2">*/}
                    {/*    Delete*/}
                    {/*  </button>*/}
                    {/*</div>*/}
                    <br />
                  </div>
                </div>
              ))}
          </div>
        </div>

        <footer className="bg-white p-3 mt-5">
          <div className={`d-${buttonTimeSlot == true ? "block" : "none"}`}>
            <div className="d-flex justify-content-end">
              <button
                onClick={() =>
                  history.push(
                    `/merchant/marketing/promo/flash-deals/time-slot-listing?promoslotid=${promoslotid}`
                  )
                }
                type="button"
                className="btn btn-outline-danger mx-2"
              >
                Cancel
              </button>
              <button
                onClick={() => saveActionAll()}
                type="button"
                className="btn btn-danger mx-2"
              >
                Confirm
              </button>
            </div>
          </div>
        </footer>
      </div>
    </React.Fragment>
  );
};

export default MerchantFlashDealsProductCreate;
